import { Button, Flex,Text ,IconButton} from "@chakra-ui/react";
import { Outlet, useNavigate } from "react-router";
import { fetchUserAttributes, signInWithRedirect, signOut } from "@aws-amplify/auth";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {userContextAction} from '../store/UserContext';
import PTCMenu from "../components/PTCMenu";
import { TbMenu2 } from "react-icons/tb";
const extractUserData = (attr)=>{
  const name = attr.name;
  const email = attr.email;
  const parsedData = JSON.parse(attr.identities)[0];
  const userId = parsedData.userId;
  const provider = parsedData.providerType;
  const picture = attr.picture;
  const company=attr["custom:company"];
  return {name, email, userId, provider,picture, company};
}
const Home = ()=>{
    const [menuOpen, setMenuOpen] = useState(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [user, setUser] = useState({});
    useEffect(()=>{
        getUserData();
    },[]);
  const getUserData = async ()=>{
    try{
      dispatch(userContextAction.loadingOn())
      const attr = await fetchUserAttributes();
      const userAttr = extractUserData(attr);
      setUser(userAttr);
      dispatch(userContextAction.setUser(userAttr));
    }catch(err){
        await signOut(); 
        await signInWithRedirect();
    }finally{
      dispatch(userContextAction.loadingOff())
    }
    
  }


  const handleSignout = async () =>{
        await signOut(); 
        await signInWithRedirect();
  }

    return(
        <Flex w={'100vw'} flexDir={'column'} gap={'5px'}>
            <IconButton position={"fixed"} top="20px" left={"20px"} onClick={(e)=>setMenuOpen(!menuOpen)}>
            <TbMenu2/>
          </IconButton>
            <PTCMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
            
            
            {/* <Text>Hello : {user.name}</Text>
            <Text>Company : {user.company}</Text>
            <Button onClick={()=>{handleSignout()}}>Sign out</Button> */}
            <Outlet context={user}/>
        </Flex>
    );
}
export default Home;